import { GeneralAPIResBody } from "../types/api-types";
import { post } from "./api";

export const claimMission = async (missionID: string) => {
  return post<GeneralAPIResBody>({
    uri: `/mission/${missionID}/claim`,
  });
};
